import { i18n, _t } from "app/i18n/i18n";
import { HTMLComponent } from "lib/HTMLComponent";
import { NotAvailable } from "lib/SimpleTable";
import { LoadingSpinner } from "lib/Spinner";
import { useFetch } from "lib/useFetch";
import { noop } from "lib/utils";
import React, { useEffect } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { SearchButton } from "./SearchButton";
import "./tooltip.css";

export const SearchTooltip = ({ className = "" }) => (
  <OverlayTrigger
    trigger={["focus"]}
    placement="bottom-end"
    overlay={
      <Overlay>
        <TooltipBody />
      </Overlay>
    }
  >
    <Button aria-label="question mark" variant="none" className={className}>
      <i className="far fa-question-circle fa-lg text-secondary hover-em"></i>
    </Button>
  </OverlayTrigger>
);

const Overlay = React.forwardRef(({ popper, children, show: _, ...props }, ref) => {
  useEffect(() => {
    popper.scheduleUpdate();
  }, [children, popper]);
  return (
    <Popover ref={ref} {...props} className="search-tooltip shadow px-0">
      <Popover.Title as="h3">{_t("Search Tips")}</Popover.Title>
      <Popover.Content>{children}</Popover.Content>
    </Popover>
  );
});

const TooltipBody = () => {
  const tooltipUrl = process.env.PUBLIC_URL + "/api/tooltips/search-tooltips-" + i18n.getLanguage() + ".json";
  const [data, isLoading, err] = useFetch(tooltipUrl, null, "GET");

  if (isLoading) return <LoadingSpinner />;
  if (err) return <NotAvailable />;

  return (
    <section>
      {data.map((item, index) => (
        <SearchTipItem key={index} {...item} />
      ))}
    </section>
  );
};

function SearchTipItem({ label, value, title, footer, hideHr }) {
  return (
    <article>
      <header>
        <b>{title}</b>
      </header>
      {label && (
        <Row noGutters className="align-items-center">
          <Col md={7}>
            <HTMLComponent className="mb-2" html={label} />
          </Col>
          <Col md={5}>{Searchbox(value)}</Col>
        </Row>
      )}
      <footer>
        <HTMLComponent html={footer} />
      </footer>
      {!hideHr && <hr className="my-2" />}
    </article>
  );
}

const Searchbox = (value) => (
  <InputGroup className="mb-2" size="sm">
    <Form.Control as="input" value={value} readOnly size="sm" />
    <InputGroup.Append>
      <SearchButton onClick={noop} />
    </InputGroup.Append>
  </InputGroup>
);
